import Vue from 'vue'
import Router from 'vue-router'
import home from "@/view/home";
import login from "@/view/login/login";
import order from "@/view/order/index";
import index from "@/view/index/index";
import error from "@/view/error/error";
import announcement from "@/view/announcement/index";
import appointment from "@/view/inspection/appointment";
import info from "@/view/inspection/info";
import check from "@/view/inspection/check";
import goCheck from "@/view/inspection/goCheck";
import greenChannel from "@/view/inspection/greenChannel";
import submittedSuccessfully from "@/view/order/submittedSuccessfully";
import orderInfor from "@/view/order/orderInfor";
import comments from "@/view/comments/index";
import remark from "@/view/remark";
import appointmentTips from "@/view/inspection/appointmentTips";
import greenTips from "@/view/inspection/greenTips";
import introduce from "@/view/introduce/introduce";
import couponIndex from "@/view/coupon/index";

Vue.use(Router);

export default new Router({
    mode: 'history',
    routes: [
        {
            path: '/login',
            name: 'login',
            component: login,
            meta: {title: '登录'}
        },
        {
            path: '/',
            component: home,
            children: [
                {path: '/', component: index, name: 'home', meta: {title: '在线检车'}},
                {path: '/order', component: order, name: 'order', meta: {title: '订单'}},
            ]
        },
        {
            path: '/info',
            component: info,
            name: 'info',
            meta: {title: '使用说明'}
        },
        {
            path: '/appointment',
            component: appointment,
            name: 'appointment',
            meta: {title: '上门代检'}
        },
        {
            path: '/check',
            component: check,
            name: 'check',
            meta: {title: '选择车检通道'}
        },
        {
            path: '/goCheck',
            component: goCheck,
            name: 'goCheck',
            meta: {title: '到站代检'}
        },
        {
            path: '/greenChannel',
            component: greenChannel,
            name: 'greenChannel',
            meta: {title: '预约检车'}
        },
        {
            path: '/announcement',
            component: announcement,
            name: 'announcement',
            meta: {title: '公告详情'}
        },
        {
            path: '/submittedSuccessfully',
            component: submittedSuccessfully,
            name: 'submittedSuccessfully',
            meta: {title: '生成订单'}
        },
        {
            path: '/orderInfor',
            component: orderInfor,
            name: 'orderInfor',
            meta: {title: '订单详情'}
        },
        {
            path: '/comments',
            component: comments,
            name: 'comments',
            meta: {title: '评论'}
        },
        {
            path: '/remark',
            component: remark,
            name: 'remark',
            meta: {title: '添加备注'}
        },
        {
            path: '/appointmentTips',
            component: appointmentTips,
            name: 'appointmentTips',
            meta: {title: '上门取车导办检车'}
        },
        {
            path: '/greenTips',
            component: greenTips,
            name: 'greenTips',
            meta: {title: '预约检车'}
        },
        {
            path: '/introduce',
            component: introduce,
            name: 'introduce',
            meta: {title: '年检介绍'}
        },
        {
            path: '/coupon',
            component: couponIndex,
            name: 'index',
            meta: {title: '车检优惠券'}
        },
        {
            path: '/',
            name: '找不到',
            component: error,
            children: [
                {path: '*', component: error, name: '404'}
            ]
        }
    ]
})
